<template>
  <div class="join">
    <container>
      <div class="join__content">
        <div class="join__content__preview">
          <img class="join__content__preview__image" :src=" content && content.form_preview.path " alt="Mitgliedschaftsformular"
               @click=" openDocument ">
        </div>
        <div class="join__content__text">
          <h2 class="join__content__text__title">Mitglied werden</h2>
          <p class="join__content__text__intro" v-html=" content && content.text "></p>
        </div>
  </div>
    </container>
  </div>
</template>

<script>
import {api} from '@/main.js'
import Container from "@/components/container/index";
export default {
  name: 'OnepageJoin',
  components: {Container},
  data () {
    return {
      content: false
    }
  },
  methods: {
    openDocument () {
      window.open(this.content.form_file.path, '_blank');
    }
  },
  mounted () {
    api.singleton.get('join').then(response => {
      this.content = JSON.parse(response.data)
      this.content.form_preview.path = api.url + this.content.form_preview.path
      this.content.form_file.path = api.url + '/storage/uploads' + this.content.form_file.path
    })
  }
}
</script>

<style lang="scss" scoped>
  .join {
    &__content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &__text {
        width: 60%;
        padding: 0 3rem;

        &__title {
          font-size: $size_title;
        }
        &__intro {
          font-size: $size_text;
        }
      }
      &__preview {
        width: 30%;

        &__image {
          width: 100%;
          height: auto;
          box-shadow:0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);

          &:hover,
          &:focus {

            box-shadow:0 2px 4px 0 rgba(0, 0, 0, 0.23);
            cursor: pointer;
          }
        }
      }
    }

    @media (max-width: 777px) {
      margin-top: -4rem;

      &__content { flex-direction: column-reverse; text-align: justify }
      &__content__text, &__content__preview { padding: 1rem 0; width: 100%; }
      &__content__text__title {
        text-align: center
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/onepage/join.vue